import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Questionnaire from "@/pages/Questionnaire";
import ThankYou from "@/pages/ThankYou";
import Admin from "@/pages/Admin";
import AdminDetail from "@/pages/AdminDetail";
import Login from "@/pages/Login";

function App() {
  return (
    <div className="App tt-grain">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/start" element={<Questionnaire />} />
            <Route path="/done/:submissionId" element={<ThankYou />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/:submissionId"
              element={
                <ProtectedRoute>
                  <AdminDetail />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
